import { render } from "./SMagazineTyp.vue?vue&type=template&id=6bf48c00"
import script from "./SMagazineTyp.vue?vue&type=script&lang=js"
export * from "./SMagazineTyp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__